export default __webpack_public_path__ + "static/media/ShanelleLovelace.017af9f5.png";